import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useStateContext } from "../../context/ContextProvider";
import { EditTextQill } from "./utils";
import { DLabel, DSpinButton, TextArea } from "../utils/Form";
import { toast } from "react-toastify";
import { Loader } from "../utils";
import { useParams } from "react-router-dom";
import { BaseUrl, media } from "../../server";
import { getCategory } from "../../redux/actions/category";
import ImageUploadWithResize from "../../utils/ImageUploadWithResize";


function Editcategory() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();
  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const { id } = useParams();
  
  useEffect(() => {
    dispatch(getCategory(id));
  }, [dispatch, id]);
  
  const { CategoryData, isLoading } = useSelector((state) => state.Categorys);
  const [titleAr, setTitleAr] = useState(CategoryData?.titleAr);
  const [titleEn, setTitleEn] = useState(CategoryData?.titleEn);
  const [textEn, setTextEn] = useState(CategoryData?.textEn);
  const [textAr, setTextAr] = useState(CategoryData?.textAr);
  const [image, setImage] = useState(CategoryData?.Image);
  const [imageShow, setImageShow] = useState(null);

  useEffect(() => {
    if (CategoryData) {
      setTitleAr(CategoryData.titleAr);
      setTitleEn(CategoryData.titleEn);
      setTextEn(CategoryData.textEn);
      setTextAr(CategoryData.textAr);
      setImage(CategoryData.Image);
      setImageShow({ url: `${media}${CategoryData.Image}` });
    }
  }, [CategoryData]);

  const Updatecategory = async (newForm) => {
    try {
      const config = { 
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true 
      };
      const { data } = await axios.put(
        `${BaseUrl}/category/${id}`,
        newForm,
        config
      );
      
      if (data.success) {
        toast.success(
          <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
            {t("Meals Category updated successfully!")}
          </span>
        );
        setIsSpinner(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
    const newForm = new FormData();
    
    // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها (إذا كانت من نوع File)
    if (image instanceof File) {
      newForm.append("file", image);
    }
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);

    Updatecategory(newForm);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10 rounded-3xl">
          <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
            {t("Edit Meal Category")}
          </h3>
          <form onSubmit={handleSubmit}>
            <br />
            <div>
              <DLabel
                labelText="Title (Ar)"
                value={titleAr}
                onChange={(e) => {
                  setTitleAr(e.target.value);
                }}
                required={true}
                type="text"
                name="titleAr"
              />
              <DLabel
                labelText="Title (En)"
                value={titleEn}
                onChange={(e) => {
                  setTitleEn(e.target.value);
                }}
                required={false}
                type="text"
                name="titleEn"
              />

              <div className="relative flex-col items-center mb-4 h-auto pb-5">
                <TextArea 
                  labelText="Description (ar)" 
                  className="pb-2 text-tcolor-5 text-md font-kufi" 
                  type="text"
                  name="textAr" 
                  value={textAr} 
                  onChange={(e) => setTextAr(e.target.value)} 
                />
              </div>

              <div className="relative flex-col items-center mb-4 h-auto pb-5">
                <TextArea 
                  labelText="Description (en)" 
                  className="pb-2 text-tcolor-5 text-md font-kufi" 
                  type="text"
                  name="textEn" 
                  value={textEn} 
                  onChange={(e) => setTextEn(e.target.value)} 
                />
              </div>

              {/* استخدام كمبوننت ضغط الصور الجديد */}
              <ImageUploadWithResize
                imageShow={imageShow}
                setImageShow={setImageShow}
                setImage={setImage}
                currentColor={currentColor}
                label="Upload Image"
                required={false}
                maxWidth={1024}
                maxHeight={1024}
                quality={80}
              />
              
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>{t("Edit")}</DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default Editcategory;